// extracted by css-extract-rspack-plugin
export default {"summary":"summary-_QkV_y","summaryBody":"summaryBody-EH1viv"};